<template>
  <div class="PersonelIoInfoInDateListWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      :items="list"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 50, 100, -1],
        'items-per-page-text': $t('rowsPerPage'),
        'show-first-last-page': true,
      }"
      @click:row="handleClick"
    >
      <template v-slot:item.status="{ item }">
        <span>
          {{ item.status == '10' ? 'تایید نهایی':'' }}
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    list() {
      this.selectedList = [];
    },
  },
  data() {
    return {
      selectedList: [],
      headers: [
        {
          text: this.$t("card-no"),
          value: "PERNO",
        },
        {
          text: this.$t("person-name"),
          value: "personName",
        },
        {
          text: this.$t("DayName"),
          value: "enterDayName",
        },
        {
          text: this.$t("EntryDate"),
          value: "beginDate",
        },
        {
          text: this.$t("EntryTime"),
          value: "BeginTime",
        },
        {
          text: this.$t("ExitTime"),
          value: "endTime",
        },
        {
          text: this.$t("ExitDate"),
          value: "endDate",
        },
        {
          text: this.$t("type"),
          value: "type",
        },
        {
          text: this.$t("status"),
          value: "position",
        },
        {
          text: this.$t("statusName"),
          value: "status",
        },
      ],
    };
  },
  methods: {
    handleClick(value) {
      this.$emit("onClick", value);
    },
  },
};
</script>

<style>
</style>